<template>
    <SfSection v-if="image">
        <LazyImg
            v-if="image"
            :src="image.url_sm"
            :src-tiny="image.url_tiny"
            :srcset="`
                ${image.url_xs} 320w,
                ${image.url_sm} 600w,
                ${image.url_md} 800w,
                ${image.url_lg} 1280w
            `"
            sizes="
                (max-width: 380px) 320px,
                100vw
            "
            :width="image.width"
            :height="image.height"
            :alt="image.alt || ''"
            :caption="caption"
            :has-focal-point="image?.hasFocalPoint"
            :focal-point="image?.focalPoint"
        />
    </SfSection>
</template>

<script>
import { get } from 'lodash-es';

import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import LazyImg from '~/patterns/atoms/lazy-img/lazy-img';

export default {
    components: {
        SfSection,
        LazyImg
    },

    mixins: [
        contentBlockMixin
    ],

    computed: {
        image() {
            return get(this, 'block.image.0', null);
        },

        caption() {
            return get(this, 'block.caption', '');
        }
    }
};
</script>
